<template>
  <ion-header>
    <ion-toolbar>
      <ion-item lines="none">
        <ion-title>{{ $t('editBooking') }}</ion-title>
        <ion-icon slot="end" style="font-size: 30px;" @click="closeDialog()" :ios="closeOutline" :md="closeOutline" name="closeOutline"></ion-icon>
      </ion-item>
    </ion-toolbar>
  </ion-header>
  <ion-content class="ion-padding">
    <ion-card>
      <ion-card-header>
        <ion-card-title v-if="slot">
          {{ dayjs(slot.date).format('DD.MM.YYYY HH:mm') }} {{ selectedRange.selectedItem.name }}
        </ion-card-title>
      </ion-card-header>
      <ion-list  v-show="selectedRange" lines="full" class="ion-no-margin">
        <ion-item>
          <ion-icon slot="start" :ios="arrowForwardCircleOutline" :md="arrowForwardCircleOutline"></ion-icon>
          <ion-select v-if="selectedRange" interface="popover" slot="start" v-model="selectedInterval">
            <ion-select-option v-for="(item, index) in selectedRange.interval_selection" :key="index" :value="item">{{ item }}</ion-select-option>          
          </ion-select>
          <ion-label  v-if="selectedRange" slot="start">{{ selectedRange.interval_name }}</ion-label>
        </ion-item>
        <ion-item v-if="selectedRange && selectedRange.interval_hint != ''">
          <ion-label>{{ selectedRange.interval_hint }}</ion-label>
        </ion-item>
        <ion-item v-if="slot && slot.priceFloat > 0">
          <h3>{{ $t('amountToPay') }}: {{ (slot.priceFloat * selectedInterval * selectedRange.intervalDivisor).toFixed(2) }} {{ slot.currencySymbol }}</h3>
          <ion-checkbox v-if="selectedRange && selectedRange.paymentEnabled" :disabled="slot.forceRangePayment && slot.payRangefee" v-model="slot.payRangefee" slot="end"></ion-checkbox>
        </ion-item>
        <ion-item v-show="selectedRange && selectedRange.paymentEnabled && slot.payRangefee && slot.priceFloat > 0">
          <ion-label position="stacked">{{ $t('makeAndPayRangeBooking')}}</ion-label>
          <div style="margin-top: 5px;" id="paypalButton"></div>
          <!-- <ion-select style="min-width: 100% !important;" interface="popover" v-model="paymenttype" :value="paymenttype">
            <ion-select-option v-if="isSuccessfullBraintreePaypalAuthorized" value="PayPalAccount">{{ $t('paypalPayment') }}</ion-select-option>  
            <ion-select-option v-if="isSuccessfullBraintreeCreditCardAuthorized" value="CreditCard">{{ $t('creditCardPayment') }}</ion-select-option>  
          </ion-select>-->
        </ion-item>
        <ion-button v-if="(selectedRange && !selectedRange.paymentEnabled)  || (slot && !slot.payRangefee)" style="margin-top: 15px;" expand="block" color="primary" @click="doBooking()">{{ slot.payRangefee && selectedRange.paymentEnabled ? $t('makeAndPayRangeBooking') : $t('makeRangeBooking') }}</ion-button>
      </ion-list>
    </ion-card>
  </ion-content>
</template>

<script>
import { IonButton, IonContent, IonHeader, IonTitle, toastController, IonSelect, IonSelectOption,
IonToolbar, IonLabel, IonInput, IonItem, IonList, IonIcon, IonItemDivider, loadingController,
IonGrid, IonCol, IonRow, modalController, IonCheckbox, IonCard, IonCardHeader, IonCardTitle } from '@ionic/vue';
import { defineComponent, ref } from 'vue';
import { closeOutline, pawSharp, stopCircleOutline, logInOutline, squareSharp, personSharp, 
          personAddOutline, trashOutline, timeOutline, arrowForwardCircleOutline } from 'ionicons/icons';
import { useMutation } from '@vue/apollo-composable'
import saveRangeBookingMutationFile from '../../graphql/saveRangeBooking.mutation.gql'
import createPaymentMutationFile from '../../graphql/createPayment.mutation.gql'
import * as dayjs from 'dayjs';
import { loadScript } from "@paypal/paypal-js";
import { getClubInfo } from '@/composition'

export default defineComponent({
  name: 'EditRangeBookingDialog',
  components: { IonButton, IonContent, IonHeader, IonTitle, IonToolbar,IonLabel, IonInput, IonItem, 
                IonList, IonIcon, IonGrid, IonCol, IonRow, IonItemDivider, IonCheckbox, IonCard, IonCardHeader,
                IonCardTitle, IonSelect, IonSelectOption,
              },
  props: ['propsData'],
  setup() {
    let slot = ref()
    let selectedRange = ref()
    let selectedInterval = ref(0)
    const clubInfo = ref(getClubInfo())

    const { mutate: saveRangeBookingMutation } = useMutation(saveRangeBookingMutationFile, { fetchPolicy: 'no-cache' });
    const { mutate: createPaymentMutation } = useMutation(createPaymentMutationFile, { fetchPolicy: 'no-cache' });

    return {
      saveRangeBookingMutation, 
      dayjs,
      closeOutline, pawSharp, stopCircleOutline, logInOutline, squareSharp, personSharp, personAddOutline,
      trashOutline,timeOutline, slot, selectedRange, selectedInterval, arrowForwardCircleOutline, createPaymentMutation, clubInfo
    }
  },
  computed: {
      isSuccessfullBraintreePaypalAuthorized : function(){ return this.$store.getters.isSuccessfullBraintreePaypalAuthorized},
      isSuccessfullBraintreeCreditCardAuthorized : function(){ return this.$store.getters.isSuccessfullBraintreeCreditCardAuthorized },
      paymenttype : function(){ 
        return 'PayPalAccount'
/*        if (this.isSuccessfullBraintreePaypalAuthorized && this.isSuccessfullBraintreeCreditCardAuthorized )
          return 'PayPalAccount'
        else if (this.isSuccessfullBraintreePaypalAuthorized)
          return 'PayPalAccount'
        else if (this.isSuccessfullBraintreeCreditCardAuthorized)
          return 'CreditCard' */
       },
  },
  mounted() {
    this.slot = this.propsData.slot
    this.selectedRange = this.propsData.selectedRange
    this.selectedInterval = this.selectedRange.interval_selection[0]

    loadScript({ "client-id": "AQe-1_UiC8WAkzp_FORkgq6UT6rRyNqXv2g74Q7ZczFrEIGCwAG65v6m6W3BcNNamN7gtuoNfahiRH0v", currency: this.clubInfo.clubInfo.currency }).then((paypal) => {
    paypal.Buttons({
        style: {
          shape: 'rect',
          color: 'blue',
          layout: 'vertical',
          label: 'pay',
          
        },
        createOrder: async () => {
          const price = this.slot.payRangefee ? (this.slot.priceFloat * this.selectedInterval * this.selectedRange.intervalDivisor) : 0
          const p = await this.createPaymentMutation({ description: this.$t('ranges') + " " + this.selectedRange.selectedItem.name, amount: parseFloat(price), paymentType: 'payPal' })
          if (!p.data.createPayment.success) {
            return ''
          }
          return p.data.createPayment.token
         },
         onError: async (err) => {
            toastController
              .create({
                message: this.$t('invalidPayment'),
                duration: 3000,
                color: 'danger'
              }).then(res => res.present())
         },
         onApprove: async (data,actions) => {
            this.buttonDisabled = true
            loadingController.create().then(res => {
              res.present()
            }).catch(err => { })
            this.saveRangeBookingMutation({ date: this.slot.date, rangeId: this.selectedRange.selectedItem.id, interval: this.selectedRange.interval_selection.findIndex(i => i == this.selectedInterval) + 1, price: this.slot.payRangefee ? (this.slot.priceFloat * this.selectedInterval * this.selectedRange.intervalDivisor) : 0, paymentType: 'PayPalAccount', language: this.$store.getters.language, orderId: data.orderID })
            .then(res => {
                toastController
                  .create({
                    message: this.$t('bookingAdded'),
                    duration: 3000,
                    color: 'success'
                  }).then(res => res.present())
                  loadingController.dismiss()
                  return modalController.dismiss(true)
            })
            .catch(err => {
                loadingController.dismiss()
                toastController
                  .create({
                    message: this.$t('notSuccessful') + ': ' + err,
                    duration: 3000,
                    color: 'danger'
                  }).then(res => res.present())
            }) 
         },
         onCancel: async () => {
          const price = this.slot.payRangefee ? (this.slot.priceFloat * this.selectedInterval * this.selectedRange.intervalDivisor) : 0
          await this.createPaymentMutation({ amount: parseFloat(price), paymentType: 'payPalCancel' })
         }
     }).render("#paypalButton")});

  },
  methods: {
    doBooking() {
      loadingController.create().then(res => {
        res.present()
      }).catch(err => { })
      this.saveRangeBookingMutation({ date: this.slot.date, rangeId: this.selectedRange.selectedItem.id, interval: this.selectedRange.interval_selection.findIndex(i => i == this.selectedInterval) + 1, price: this.slot.payRangefee ? (this.slot.priceFloat * this.selectedInterval * this.selectedRange.intervalDivisor) : 0, paymentType: this.paymenttype, language: this.$store.getters.language })
      .then(res => {
          toastController
            .create({
              message: this.$t('bookingAdded'),
              duration: 3000,
              color: 'success'
            }).then(res => res.present())
            loadingController.dismiss()
            return modalController.dismiss(true)
      })
      .catch(err => {
          loadingController.dismiss()
          toastController
            .create({
              message: this.$t('notSuccessful') + ': ' + err,
              duration: 3000,
              color: 'danger'
            }).then(res => res.present())
      }) 
    },
    closeDialog() {
      return modalController.dismiss()
    },
  }
});
</script>